// Types
import Vue, { VNode } from 'vue'

/* @vue/component */
export default Vue.extend({
  name: 'v-list-item-icon',

  functional: true,

  props: {
    classPrefix: {
      type: String,
      default: '',
    },
  },

  render (h, { data, children }): VNode {
    data.staticClass = (`${this.classPrefix}v-list-item__icon ${data.staticClass || ''}`).trim()

    return h('div', data, children)
  },
})
